// extracted by mini-css-extract-plugin
export default {"spoiler":"hrQ_am_h","_isBordered":"Qjg0VvDv","_isOpened":"U6zXkHDO","title":"_n9j5aDM","arrow":"yLK89rL9","content":"C3jkU6KY"};